import { Mutations } from '@/store/types';
import Store from '@/store';
import { DeliveryAddressDto } from '@eurogast/hub-client-typescript';

export class CommonOrderDetailService {
  private static instance = new CommonOrderDetailService();

  public static singleton(): CommonOrderDetailService {
    return this.instance;
  }

  private constructor() {
  }

  public saveNotes(notes?: string) {
    Store.commit(
      {
        type: Mutations.CommonOrderDetail.setNotes,
        notes
      }
      );
  }

  public saveCustomerId(customerOrderId?: string) {
    Store.commit(
      {
        type: Mutations.CommonOrderDetail.setCustomerOrderId,
        customerOrderId
      }
    );
  }

  public saveUnloadingArea(unloadingArea?: string) {
    Store.commit(
      {
        type: Mutations.CommonOrderDetail.setUnloadingArea,
        unloadingArea
      }
    );
  }

  public saveDeliveryAddress(deliveryAddress?: DeliveryAddressDto) {
    Store.commit(
      {
        type: Mutations.CommonOrderDetail.setDeliveryAddress,
        deliveryAddress
      }
    );
  }

  public resetCheckoutState() {
    Store.commit(Mutations.CommonOrderDetail.resetCheckoutState);
  }

}
